<!--
 * @Author: your name
 * @Date: 2022-03-02 14:09:24
 * @LastEditTime: 2022-03-21 16:46:51
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /streamline_detail/src/views/home/components/skeleton/index.vue
-->
<template>
  <div style="position: fixed; left: 0; top: 0; right: 0; bottom: 0; background-color: #fff">
    <svg style="width: 100%; height: 100%" fill="#ff5555">
      <rect rx="0vw" height="100vw" width="100vw" y="0vw" x="0vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="15.99vw" y="98.35vw" x="7.99vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="14.54vw" y="98.35vw" x="28.19vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="19.19vw" y="98.35vw" x="46.93vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="12.79vw" y="98.35vw" x="70.32vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.99vw" width="3.99vw" y="97.95vw" x="89.1vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="7.99vw" width="13.29vw" y="111.19vw" x="10.89vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.73vw" width="8.5vw" y="113.96vw" x="25.28vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.7vw" width="17.09vw" y="115vw" x="34.89vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.7vw" width="14.57vw" y="115vw" x="54.42vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="19.65vw" y="121.33vw" x="7.73vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.7vw" width="85vw" y="126.97vw" x="7.49vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.7vw" width="85vw" y="133.97vw" x="7.49vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.7vw" width="10.79vw" y="144.23vw" x="7.49vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="10.96vw" y="149.38vw" x="7.49vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.7vw" width="10.79vw" y="144.23vw" x="26.7vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="14.52vw" y="149.38vw" x="26.7vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.7vw" width="10.96vw" y="144.23vw" x="49.46vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="22.8vw" y="149.38vw" x="49.46vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.7vw" width="7.33vw" y="144.23vw" x="80.51vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="12.79vw" y="149.38vw" x="80.51vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.19vw" width="3.19vw" y="146.4vw" x="89.6vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.5vw" width="17.5vw" y="164.26vw" x="7.49vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.9vw" width="43.49vw" y="169.96vw" x="7.49vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="7.99vw" width="7.99vw" y="186.75vw" x="4.29vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="28.79vw" y="186.77vw" x="23.99vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="51.82vw" y="192.07vw" x="14.39vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.19vw" width="3.19vw" y="189.42vw" x="92.5vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="7.99vw" width="7.99vw" y="200.59vw" x="4.29vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="17.86vw" y="200.61vw" x="23.99vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.2vw" width="34.55vw" y="205.91vw" x="14.39vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="3.19vw" width="3.19vw" y="203.26vw" x="92.5vw" fill="#f8f8f8"></rect>

      <rect
        rx="2.14vw"
        height="4.29vw"
        width="4.29vw"
        y="184.37vw"
        x="5.89vw"
        fill="#f8f8f8"
      ></rect>

      <rect
        rx="2.14vw"
        height="4.29vw"
        width="4.29vw"
        y="184.37vw"
        x="8.74vw"
        fill="#f8f8f8"
      ></rect>

      <rect
        rx="2.14vw"
        height="4.29vw"
        width="4.29vw"
        y="184.37vw"
        x="11.58vw"
        fill="#f8f8f8"
      ></rect>

      <rect rx="0vw" height="2.7vw" width="23.09vw" y="185.17vw" x="18.78vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.9vw" width="46.97vw" y="196.57vw" x="26.11vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="2.69vw" width="2.69vw" y="196.67vw" x="74.68vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="5.29vw" width="5.29vw" y="204.62vw" x="5.89vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="5.29vw" width="5.29vw" y="204.62vw" x="19.24vw" fill="#f8f8f8"></rect>

      <rect rx="0vw" height="10.69vw" width="66.9vw" y="204.12vw" x="29.89vw" fill="#f8f8f8"></rect>
    </svg>
  </div>
</template>

<script>
import { defineComponent, onMounted } from '@vue/composition-api'

export default defineComponent({
  setup(props, ctx) {
    const { $tiktok } = ctx.root
    $tiktok('created', '骨架屏')
    onMounted(() => {
      $tiktok('mounted', '骨架屏')
    })
    return {}
  }
})
</script>
